/* Modulos */
import { RepublicaMovilModule } from './republica-movil/republica-movil.module';
import { HomeModule} from './home/home.module';
import { SimyoModule } from './simyo/simyo.module';
import { IconsModule } from './icons/icons.module';
import { OrangeModule } from './orange/orange.module';
import { CoreModule } from './core/core.module';
/* Modulos material */
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatStepper } from '@angular/material/stepper';
/* Componentes */
import { AppComponent } from './app.component';
/* Servicios */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgxMaskOptions, NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
/* Redux */
import { StoreModule } from '@ngrx/store';
import { reducers } from './orange/redux';
import {HttpErrorInterceptor} from './core/injectables/http-error.interceptor';
import { MatGoogleMapsAutocompleteModule } from '@angular-material-extensions/google-maps-autocomplete';

import * as moment from 'moment';
import 'moment/locale/es';
import {MasmovilModule} from './masmovil/masmovil.module';
import {PepephoneModule} from './pepephone/pepephone.module';
import {GuukModule} from './guuk/guuk.module';
import { AmenaModule } from './amena/amena.module';
import { RequestOriginInterceptor } from './core/injectables/request-origin.interceptor';
import { MigrationInterceptor } from './core/injectables/migration.interceptor';
import { MatTooltipModule } from '@angular/material/tooltip';

const maskConfig: NgxMaskOptions = {
    validation: false,
};

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        CommonModule,
        AppRoutingModule,
        RepublicaMovilModule,
        AmenaModule,
        SimyoModule,
        OrangeModule,
        HomeModule,
        BrowserAnimationsModule,
        IconsModule,
        MatGoogleMapsAutocompleteModule.forRoot('AIzaSyBUT7T6HqQJnWYKy3pjPcBRYj-4Mmsd1ao'),
        StoreModule.forRoot(reducers),
        CoreModule,
        NgxMaskDirective,
        NgxMaskPipe,
        MasmovilModule,
        PepephoneModule,
        GuukModule,
        MatTooltipModule
    ],
    providers: [
        MatStepper,
        provideNgxMask(),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MigrationInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RequestOriginInterceptor,
            multi: true
        },
        provideNgxMask(maskConfig),
        provideHttpClient(withInterceptorsFromDi())
    ] })

export class AppModule {
    constructor() {
        // Establece el idioma global de moment a español
        moment.locale('es');
    }
}
